import React, { useState } from 'react'

import Box from 'components/Box'
import Search from 'components/Search'

import { MenuListProps, PopOverItem } from './types'
import MenuList from './MenuList'

const matchesTerm = (option: PopOverItem, term: string) => Boolean(option.label?.toLowerCase().includes(term))

/**
 * Narrow the list to what matches, looking inside groups.
 *
 * A grouped option's own label is the heading, and the searchable text sits on its
 * children — so matching the top level alone empties the list the moment anything
 * is typed. A group is kept when its heading matches, with all of its children
 * since the heading is what was asked for, or when any child matches, with only
 * the matching children.
 */
const filterOptions = (options: PopOverItem[] | undefined, term: string) =>
  options?.reduce<PopOverItem[]>((kept, option) => {
    if (matchesTerm(option, term)) {
      return [...kept, option]
    }

    const children = option.options?.filter((child) => matchesTerm(child, term)) ?? []

    return children.length > 0 ? [...kept, { ...option, options: children }] : kept
  }, [])

const SearchableMenuList = ({ options, onSearch, ...props }: MenuListProps) => {
  const [searchValue, setSearchValue] = useState('')

  const resolveOptions = () =>
    // When onSearch is present cosumer will handle the search
    !onSearch && searchValue ? filterOptions(options, searchValue.toLocaleLowerCase()) : options

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const tempSearchValue = e.target.value
    setSearchValue(tempSearchValue)
    onSearch?.(tempSearchValue)
  }

  return (
    <>
      <Box padding={1}>
        <Search onChange={onChange} value={searchValue} autoFocus />
      </Box>
      <MenuList {...props} isSearchable options={resolveOptions()} />
    </>
  )
}

export default SearchableMenuList
